import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Primitive, type PrimitiveProps } from 'reka-ui';
    import { type ButtonVariants, buttonVariants } from '.';
    import { LoaderCircle } from 'lucide-vue-next';

    interface Props extends PrimitiveProps {
        variant?: ButtonVariants['variant'];
        size?: ButtonVariants['size'];
        width?: ButtonVariants['width'];
        class?: HTMLAttributes['class'];
        loading?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    variant: {},
    size: {},
    width: {},
    class: {},
    loading: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: 'button' }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), {
    "data-slot": "button",
    as: _ctx.as,
    "as-child": _ctx.asChild,
    class: _normalizeClass(_unref(cn)(_unref(buttonVariants)({ variant: _ctx.variant, size: _ctx.size, width: _ctx.width }), props.class))
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
            key: 0,
            class: "h-4 w-4 animate-spin"
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "as-child", "class"]))
}
}

})